export default __webpack_public_path__ + "static/media/Capiche.61f9a579.mp4";